var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGlobalIconActive = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.19677734,16.3217773 C3.67399089,18.6530762 7.79947917,21.9055176 16.5732422,26.0791016 L18.2783203,34.5429688 L25.0673828,45.8857422 L21.8105469,49.5361328 L28.9355469,55.7587891 C25.5269881,60.0781589 25.2379604,62.7453667 28.0684637,63.7604125 C12.2504366,61.8233348 0,48.3422888 0,32 C0,26.162065 1.56330717,20.6892599 4.29412927,15.977377 C4.25379751,16.0959351 4.22166856,16.2107782 4.19677734,16.3217773 Z M32,0 C49.673112,0 64,14.326888 64,32 C64,42.680052 58.7679421,52.1380915 50.7271398,57.9508047 C53.9490694,54.4740392 53.3179457,48.4852636 54.809082,46.734375 C56.3759766,44.8945313 53.8725586,40.1489258 50.9560547,40.1489258 L29.9817766,40.1489258 L29.9817766,40.1489258 L25.0673828,32 L29.9817766,26.0791016 L35.2539062,26.0791016 L39.515625,32 L46.0048828,32 L39.515625,27.7216797 L40.9794922,11.8916016 L46.0048828,11.8916016 L39.515625,3.18847656 L25.0673828,5.51269531 C20.7832031,4.26920573 17.6923828,3.95833333 15.7949219,4.58007812 C15.3740897,4.71797305 14.8412894,4.99533693 14.2362974,5.37921568 C19.3173213,1.98162185 25.4272443,0 32,0 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#FFD110",
    xlinkHref: "#path-1"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGlobalIconActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/global-icon-active.7baf7f21c01f73b389786406dcbe08aa.svg";